
const toggleClasses = (toggleClass, classList) => {
    const level = classList.indexOf(toggleClass);
    const removeClassList = classList.slice(0, level);
    removeClassList.map(function (className) {
        return document.body.classList.remove(className);
    });
    document.body.classList.toggle(toggleClass);
};
export default toggleClasses;